module.exports = __webpack_public_path__ + "static/channels-6a5658d866f31bf67f85b52f58aa2e04.webp";